import { useState } from 'react';
import step1 from '../images/group1.png';
import step2 from '../images/group2.png';
import step3 from '../images/group3.png';
import imagenStepOne from "../images/step1img.png";
import imagenStepTwo from "../images/step2img.png";
import imagenStepThree from "../images/step3img.png";
import { BiChevronRight } from "react-icons/bi";
const useSteps = () => {

     const [steps, setSteps] = useState([
    { id: 1, 
      text: "Carga la foto de tu pliego y presione siguiente para crear.", 
      button: "Siguiente", 
      url:imagenStepOne, 
      imgNumber:step1,
      icon:<BiChevronRight style={{ fontSize: "24px" }} />
    },
    { id: 2, 
      text: "La aplicación mostrará 4 resultados posibles. Guardá los que más te gusten.", 
      button: "Siguiente", 
      url: imagenStepTwo ,
      imgNumber:step2,
      icon:<BiChevronRight style={{ fontSize: "24px" }} />
    },
    { id: 3,
      text: "En la galería podrás ver las imagenes guardadas por ti y otros usuarios.",
      button: "¡Comenzar!", 
      url: imagenStepThree, 
      imgNumber:step3 
    },
  ]);

   return { steps, setSteps };
}

export default useSteps